var _defs, _tspan;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCxeerssr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "132.29167mm",
    height: "62.567638mm",
    viewBox: "0 0 132.29167 62.567638",
    id: "svg94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs88"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-9.0826126e-7,-234.43236)"
  }, /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "10.58333302px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 117.83928,
    id: "text98"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    id: "tspan100",
    x: 16.630953,
    y: 127.62886
  }))), /*#__PURE__*/React.createElement("text", {
    xmlSpace: "preserve",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.26458332
    },
    x: 16.630953,
    y: 111.03571,
    id: "text104"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan102",
    x: 16.630953,
    y: 158.02571,
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "50.79999924px",
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text'",
      strokeWidth: 0.26458332
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g814"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 18.478614,281.01066 c -1.221726,-0.99265 -2.901601,-1.60352 -4.886906,-1.60352 -7.5594325,0 -13.59170709173874,5.57412 -13.59170709173874,11.53004 0,3.58882 2.90160049173874,5.72684 6.64313799173874,5.72684 6.1086321,0 13.5917071,-5.72684 13.6680651,-11.45368 v -50.77798 h -1.83259 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.39769614
    },
    id: "path717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 74.283355,234.43236 H 19.984296 v 7.63579 h 54.299059 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.64068604
    },
    id: "path719"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 43.082166,259.29451 c 0,-2.21437 -1.83259,-4.04696 -4.046969,-4.04696 -2.290737,0 -4.123327,1.83259 -4.123327,4.04696 0,1.29809 0.76358,2.44346 1.679874,3.13067 0.534506,0.38179 1.069011,0.68722 1.679874,0.83994 0.458147,0.0764 1.069011,0.22908 1.603516,0.22908 0.839937,0 1.679874,-0.22908 2.367095,-0.45815 0.839937,-0.22908 1.374442,-0.45814 2.214379,-0.9163 0.07636,-0.0763 0.229074,-0.0763 0.305432,-0.0763 0.229074,0 0.305432,0.30543 0.305432,0.61086 0,0.15271 0,0.38179 -0.07636,0.61086 -0.152716,0.9163 -4.581474,13.13356 -5.650485,17.10416 0,0.76359 1.374442,0.83994 1.756231,0.83994 0.687222,0 1.527159,-0.15271 2.138022,-0.61086 0.152715,-0.15271 6.18499,-21.60928 6.18499,-21.60928 0.229074,-1.06901 0.534506,-2.06166 0.610863,-2.36709 0,-0.61086 -0.610863,-0.9163 -0.763578,-0.99265 -0.152716,0 -0.305432,0 -0.687222,0.30543 -0.381789,0.30543 -3.436105,3.9706 -5.497769,3.9706 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.39769614
    },
    id: "path721"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 74.283355,281.34663 c -1.221727,-0.99265 -2.901588,-1.60351 -4.88691,-1.60351 -7.559421,0 -13.591683,5.57412 -13.591683,11.53004 0,3.58882 2.901598,5.72684 6.643127,5.72684 6.10862,0 13.591706,-5.72684 13.668067,-11.45368 v -50.77798 h -1.832601 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.39769614
    },
    id: "path723"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 106.16635,245.80968 H 74.619299 v 7.63579 h 31.547051 z m 0,-11.37732 H 74.619299 v 7.63579 h 31.547051 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.48834687
    },
    id: "path725"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 94.650456,259.92598 c 0,-1.7592 -1.407366,-3.16657 -3.166578,-3.16657 -1.759206,0 -3.166572,1.40737 -3.166572,3.16657 0,0.93825 0.527763,1.81785 1.290086,2.40426 0.35184,0.2932 0.820961,0.52776 1.290086,0.64504 0.35184,0.11728 0.70368,0.17591 1.172806,0.17591 0.645043,0 1.407366,-0.17591 1.935128,-0.35183 0.645044,-0.17592 1.114164,-0.35185 1.700569,-0.70368 0.11728,-0.0587 0.234566,-0.11729 0.351846,-0.11729 0.11728,0 0.23456,0.11729 0.23456,0.35185 0,0.11727 -0.05864,0.35183 -0.175918,0.70368 -0.05864,0.35184 -2.169698,6.86091 -2.580181,7.74052 -0.351841,0.8796 -1.641927,1.466 -2.28697,1.466 0.05864,-0.17592 0.05864,-0.35184 0.05864,-0.46912 0,-1.81785 -1.466009,-3.22521 -3.225215,-3.22521 -1.759216,0 -3.166582,1.40736 -3.166582,3.22521 0,0.93825 0.586401,1.81785 1.290086,2.40425 0.410483,0.23457 0.82097,0.46913 1.290091,0.64504 0.35184,0.0587 0.762323,0.11728 1.172806,0.11728 0.645043,0 1.407365,-0.11728 1.993771,-0.29319 0.645043,-0.23456 0.93824,-0.35185 1.524646,-0.70369 0.117281,0 0.175923,0.11728 0.175923,0.23456 0,0.0587 -0.05864,0.11728 -0.05864,0.17592 L 87.84818,287.6042 c 0,0.0587 0,0.11728 0,0.17592 0,0.35184 0.410483,0.82096 1.407371,0.82096 1.407366,0 1.641926,-0.5864 1.817844,-1.05552 l 5.453551,-17.88529 c 1.172808,-3.98754 2.111055,-7.15411 2.111055,-7.15411 0,0 1.1728,-4.10482 1.231442,-4.74987 0,-0.0586 0.05867,-0.11727 0.05867,-0.17592 0,-0.2932 -0.351844,-0.46912 -0.46912,-0.52776 -0.23456,0 -0.351844,0.11729 -0.527762,0.23456 -0.293202,0.23456 -2.638817,3.0493 -4.280748,3.10794 z",
    style: {
      fontStyle: "normal",
      fontVariant: "normal",
      fontWeight: "normal",
      fontStretch: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "'Bravura Text'",
      InkscapeFontSpecification: "'Bravura Text, Normal'",
      fontVariantLigatures: "normal",
      fontVariantCaps: "normal",
      fontVariantNumeric: "normal",
      fontFeatureSettings: "normal",
      textAlign: "start",
      letterSpacing: 0,
      wordSpacing: 0,
      writingMode: "lr-tb",
      textAnchor: "start",
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.3054173
    },
    id: "path729"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.63491094,0,0,0.63491094,18.478549,119.17752)",
    id: "g241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path228",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 151.92144,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 165.58992,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    style: {
      fontStyle: "normal",
      fontWeight: "normal",
      fontSize: "medium",
      lineHeight: 1.25,
      fontFamily: "sans-serif",
      letterSpacing: 0,
      wordSpacing: 0,
      fill: "#000000",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 1.66894257
    },
    d: "m 179.2584,280.07468 h -7.79057 v -9.29002 h 7.79057 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCxeerssr);
export default __webpack_public_path__ + "static/media/cxeerssr.33df3e968401968451c6d5bdecc4b61c.svg";
export { ForwardRef as ReactComponent };